export default "__VITE_ASSET__ChgqwMY___"